module.exports = __webpack_public_path__ + "img/Pic_Bg_Fz_FSYL.34bbf848.png";